<td>
  <div class="d-flex">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.positions.labels.assetName' | transloco }}
    </div>
    <div class="d-inline-flex text-md-left text-right">
      <web-components-instrument-details-link class="font-medium" [isin]="item.isin">
        {{ item.assetName }}
      </web-components-instrument-details-link>
    </div>
  </div>
  <div class="d-flex text-color-primary">
    <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
      {{ 'mydepot.depotoverview.positions.labels.isin' | transloco }}
    </div>
    <div class="font-light">{{ item.isin }}</div>
    <web-components-watchlist-toggle [isin]="item.isin" />
  </div>
</td>
<td [ngClass]="{ 'hidden-sm hidden-xs': item.endfaellig || item.knockedOutFlag }">
  @if (!item.endfaellig && !item.knockedOutFlag) {
    <div class="d-flex justify-content-end">
      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
        {{ 'mydepot.depotoverview.positions.labels.quote' | transloco }}
      </div>

      <div class="text-color-primary" [zeroBlink]="true" [val]="item.quote">
        @if (item.quote < 50) {
          {{ item.quote | currency: 'EUR' : 'symbol' : '1.3' }}
        } @else {
          {{ item.quote | currency: 'EUR' : 'symbol' : '1.2' }}
        }
      </div>
    </div>
    <div class="d-flex text-color-primary justify-content-end">
      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
        {{ 'mydepot.depotoverview.positions.labels.currentValue' | transloco }}
      </div>
      <div class="text-color-primary">
        {{ item.currentValue | currency }}
      </div>
    </div>
  }
</td>

@for (dividendPeriod of dividendPeriods; track $index) {
  @if (dividendPeriod | endsWith: 'e') {
    <ng-container *ngTemplateOutlet="dividendExpectedByYear; context: { year: dividendPeriod }" />
  } @else {
    <ng-container *ngTemplateOutlet="dividendEarnedByYear; context: { year: dividendPeriod, istotal: $index === 3 }" />
  }
}

<ng-template #dividendEarnedByYear let-year="year" let-istotal="istotal">
  <td [class.pr-0]="istotal">
    <div [class.d-lg-flex]="istotal" [class.align-items-lg-center]="istotal" [class.justify-content-lg-end]="istotal">
      <div>
        <div class="d-flex align-items-center justify-content-end text-color-primary">
          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
            @if (year === 'total') {
              <ng-container *ngTemplateOutlet="totalLabel" />
            } @else {
              {{ year }}
            }
            {{ 'mydepot.depotoverview.positions.labels.dividend-earned' | transloco }}
          </div>
          <div class="text-color-primary" [class.font-bold]="istotal">
            @if (dividendAbsoluteValues[year]) {
              {{ dividendAbsoluteValues[year] | bigNumbers: '1.2-2' : true : 9999 }}
            } @else {
              <ng-container *ngTemplateOutlet="novalue" />
            }
            @if (istotal) {
              €
            }
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end text-color-primary">
          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
            @if (year === 'total') {
              <ng-container *ngTemplateOutlet="totalLabel" />
            } @else {
              {{ year }}
            }
            {{ 'mydepot.depotoverview.positions.labels.dividend-yield' | transloco }}
          </div>
          <div
            class="text-color-primary"
            [class.text-color-success]="dividendAbsoluteValues[year] && dividendYieldValues[year] > 0"
            [class.text-color-error]="dividendAbsoluteValues[year] && dividendYieldValues[year] < 0"
            [class.text-color-secondary]="!dividendAbsoluteValues[year] || !dividendYieldValues[year]"
            [class.font-bold]="istotal"
          >
            @if (dividendYieldValues[year]) {
              {{ dividendYieldValues[year] | bigNumbers: '1.2-2' : true : 9999 }} %
            } @else {
              <ng-container *ngTemplateOutlet="novalue" />
            }
          </div>
        </div>
      </div>
      @if (istotal) {
        <div class="vertical-separator hidden-xs hidden-sm hidden-md"></div>
      }
    </div>
  </td>
</ng-template>
<ng-template #dividendExpectedByYear let-year="year">
  <td>
    <div class="d-flex align-items-center justify-content-end">
      <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
        {{ year }} {{ 'mydepot.depotoverview.positions.labels.dividend-expected' | transloco }}
      </div>

      <div class="text-color-primary">
        @if (dividendAbsoluteValues[year]) {
          ~ {{ dividendAbsoluteValues[year] | bigNumbers: '1.2-2' : true : 9999 }}
        } @else {
          <ng-container *ngTemplateOutlet="novalue" />
        }
      </div>
    </div>
  </td>
</ng-template>

<ng-template #totalLabel>{{ 'mydepot.depotoverview.positions.labels.dividend-total' | transloco }}</ng-template>
<ng-template #novalue>&mdash;</ng-template>
